import service from "./service"

const createBackgroundRequest = async (data) => {
    return service(data)
}

export default createBackgroundRequest
